export default __webpack_public_path__ + "static/media/ags.15e9312b.jpg";